import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=36e2c72c"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e2c72c')) {
      api.createRecord('36e2c72c', component.options)
    } else {
      api.reload('36e2c72c', component.options)
    }
    module.hot.accept("./ActivityItem.vue?vue&type=template&id=36e2c72c", function () {
      api.rerender('36e2c72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/ActivityItem.vue"
export default component.exports